<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Принятие актов</h3>
      <div class="filters">
        <div class="row col-md-6">
          <div class="el-input-group">
            <label for="bin" class="form-label col-md-3"></label>
            <div class="col-md-9">
              <div class="input-group">
                <input class="form-control" type="text" placeholder="Поиск по БИН/Номер акта"
                       id="bin"
                       v-model="page.filter.search"
                       style="font-style: italic;">
                <button class="btn btn-primary" type="button" @click="reloadList()">
                  Найти
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row col-md-6">
          <div class="el-input-group">
            <label for="filterMonth" class="form-label col-md-3">
              Учетный месяц
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.month" id="filterMonth"
                      v-on:change="reloadList()"
                      class="form-select">
                <option v-for="(monthName, index) in months" :key="index" :value="index + 1">
                  {{ monthName }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-6">
          <div class="el-input-group">
            <label for="filterYear" class="form-label col-md-3">
              Учетный год
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.year" id="filterYear"
                      v-on:change="reloadList()"
                      class="form-select">
                <option v-for="(year, index) in years" :key="index" :value="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-6">
          <div class="el-input-group">
            <label for="status" class="form-label col-md-3">
              Населенный пункт
            </label>
            <div class="col-md-9">
              <multiselect
                  v-model="page.filter.kato"
                  :options="katoList"
                  :searchable="true"
                  :closeOnSelect="true"
                  :custom-label="formattedKatoLabel"
                  placeholder="Выберите Като"
                  :multiple="false"
                  :clear-on-select="true"
                  @select="reloadList()"
              />
            </div>
          </div>
        </div>

        <div class="row col-md-6">
          <div class="el-input-group">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="hideAcceptedActs"
                     v-on:change="reloadList()"
                     v-model="page.filter.hideAcceptedActs"/>
              <label class="form-check-label" for="hideAcceptedActs">
                Скрывать утвержденные акты
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-end">
      <b-button variant="success"
                :disabled="items.length === 0"
                @click="onClickGenerateReport()">
        Экспортировать в MS Excel
      </b-button>

      <b-button variant="success"
                style="margin-left: 10px"
                @click="onClickAllRefresh(page)">
        Запрос в АИИС ЭГЗ
      </b-button>
    </div>

    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(bin)="data">
        <div class="sortable-container none"
             @click="onSortChanged('bin')"
             :class="{'ascending': page.sort.bin === 'ASC', 'descending': page.sort.bin === 'DESC'}">
          БИН ДО
        </div>
      </template>
      <template #head(kindergartenName)="data">
        <div class="sortable-container none"
             @click="onSortChanged('kindergartenName')"
             :class="{'ascending': page.sort.kindergartenName === 'ASC', 'descending': page.sort.kindergartenName === 'DESC'}">
          Наименование ДО
        </div>
      </template>
      <template #head(lmsId)="data">
        <div class="sortable-container none"
             @click="onSortChanged('lmsId')"
             :class="{'ascending': page.sort.lmsId === 'ASC', 'descending': page.sort.lmsId === 'DESC'}">
          ID LMS
        </div>
      </template>
      <template #head(numberAct)="data">
        <div class="sortable-container none"
             @click="onSortChanged('numberAct')"
             :class="{'ascending': page.sort.numberAct === 'ASC', 'descending': page.sort.numberAct === 'DESC'}">
          Номер акта
        </div>
      </template>
      <template #head(signedAmount)="data">
        <div class="sortable-container none"
             @click="onSortChanged('signedAmount')"
             :class="{'ascending': page.sort.signedAmount === 'ASC', 'descending': page.sort.signedAmount === 'DESC'}">
          Сумма подписанного расчета
        </div>
      </template>
      <template #head(approveDate)="data">
        <div class="sortable-container none"
             @click="onSortChanged('approveDate')"
             :class="{'ascending': page.sort.approveDate === 'ASC', 'descending': page.sort.approveDate === 'DESC'}">
          Дата утверждения
        </div>
      </template>
      <template #head(statusNameRu)="data">
        <div class="sortable-container none"
             @click="onSortChanged('statusNameRu')"
             :class="{'ascending': page.sort.statusNameRu === 'ASC', 'descending': page.sort.statusNameRu === 'DESC'}">
          Статус в АИИС ЭГЗ
        </div>
      </template>
      <template #head(locality)="data">
        <div class="sortable-container none"
             @click="onSortChanged('locality')"
             :class="{'ascending': page.sort.locality === 'ASC', 'descending': page.sort.locality === 'DESC'}">
          Населенный пункт
        </div>
      </template>

      <template #cell(bin)="data">
        {{ data.item.bin }}
      </template>
      <template #cell(kindergartenName)="data">
        {{ data.item.kindergartenName }}
      </template>
      <template #cell(lmsId)="data">
        {{ data.item.lmsId }}
      </template>
      <template #cell(numberAct)="data">
        {{ data.item.numberAct }}
      </template>
      <template #cell(approveDate)="data">
        {{ formatDate(data.item.approveDate) }}
      </template>
      <template #cell(statusNameRu)="data">
        {{ data.item.statusNameRu }}
      </template>
      <template #cell(actions)="data">
        <button @click="onClickRefreshStatus(data.item)"
                v-if="!data.item.accepted"
                class="btn btn-sm btn-success">
          Запрос в АИИС ЭГЗ
        </button>
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import {
  acceptActReconciliation,
  generateReport,
  getAllActReconciliations,
  refreshAllActReconciliation
} from "@/services/actService";
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {VerificationStatusEnum} from "@/enums/VerificationStatus";
import {TemplateTypeEnum} from "@/enums/TemplateType";
import {saveAs} from "@/assets/FileSaver.min.js";
import Multiselect from "vue-multiselect";
import cacheService from "@/services/cacheService";

export default {
  components: {
    Multiselect,
    VueLoading
  },
  data() {
    return {
      showModal: false,
      isLoading: false,
      page: {
        filter: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          bins: null,
          verificationStatus: VerificationStatusEnum.SUCCESSFUL,
          accepted: false,
          search: null,
          hideAcceptedActs: true
        },
        sort: {},
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      months: [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ],
      years: Array.from({length: 11}, (v, i) => 2024 + i),
      fields: [
        {key: 'bin', label: 'БИН ДО', sortable: true},
        {key: 'kindergartenName', label: 'Наименование ДО', sortable: true},
        {key: 'lmsId', label: 'ID LMS', sortable: true},
        {key: 'numberAct', label: 'Номер акта', sortable: true},
        {key: 'signedAmount', label: 'Сумма подписанного расчета', sortable: true},
        {key: 'approveDate', label: 'Дата утверждения', sortable: true},
        {key: 'statusNameRu', label: 'Статус в АИИС ЭГЗ', sortable: true},
        {key: 'locality', label: 'Населенный пункт', sortable: true},
        {key: 'actions', label: '', sortable: true}
      ],
      katoList: [],
      items: []
    };
  },
  methods: {
    async fetchCachedDatas() {
      this.katoList = await cacheService.useKatoStore().fetchKato();
    },
    formattedKatoLabel(item){
      return `${item.code} | ${item.nameRu}`;
    },
    async onClickRefreshStatus(item) {
      const token = localStorage.getItem("access_token");
      if (token) {
        this.isLoading = true;
        const updatedItem = await acceptActReconciliation(token, item);
        Object.assign(item, updatedItem);
        this.isLoading = false;
      }
    },
    async onClickAllRefresh(page) {
      this.isLoading = true;
      await refreshAllActReconciliation(page, 'accept');

      this.reloadList();

      this.isLoading = false;
    },
    async onClickGenerateReport() {
      const token = localStorage.getItem("access_token");
      if (token) {
        this.isLoading = true;
        const response = await generateReport(token, TemplateTypeEnum.ACT_ACCEPTANCE_XLSX, this.page);
        const blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        saveAs(blob, "document.xlsx");
        this.isLoading = false;
      }
    },
    async reloadList() {
      const token = localStorage.getItem("access_token");
      if (token) {
        this.isLoading = true;

        console.log(this.page.sort);

        const response = await getAllActReconciliations(token, this.page);
        this.items = response.list;
        this.totalCount = response.count;
        this.isLoading = false;
      }
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };

      this.reloadList();
    },
    formatDate(dateTime) {
      if (!dateTime || dateTime.length === 0) {
        return null;
      }
      return dateTime.split(" ")[0];
    }
  },
  mounted() {
    this.reloadList();
    this.fetchCachedDatas();
  }
};
</script>

<style scoped>
.filters {
  .row {
    padding-top: 5px;
  }
}

.ascending {
  background-image: url("../assets/asc.svg") !important;
}

.descending {
  background-image: url("../assets/desc.svg") !important;
}

.none {
  background-image: url("../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}
</style>